<template>
    <div class="habit-page">
        <div class="row mt-2">
            <div class="col-lg-11 col-11 mx-auto">

                <div class="list-group-item mb-2">
                    <div class="row mt-2 d-flex justify-content-center" v-if="myActionHabitDetails.length>0">
                        <div class="col-md-3 content-left">
                            <select  style="width:20em;margin-bottom:2px;" class="form-control" :hidden="myActionHabitDetails.length <1"
                                        @change="displaySelectedActionHabit()" v-model="selActionHabitID">
                                <option value="">Please Select</option>
                                <option
                                    v-for="actionhabit in myActionHabitDetails"
                                    :key="actionhabit.id"
                                    :value="actionhabit.id"
                                >{{ actionhabit.name }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row" v-if="currenthabitdata">
                        <div class="text-center bg-secondary border p-2 " style="width:100%;"">
                            <h6 v-html="'Record Your Performance:&nbsp;on your <em><u>' + currenthabitdata.name + '</em> Action-Habit</u>'" ></h6>
                        </div>
                        <div class=" content modal-body">
                            <div class="embed-responsive"> <!-- embed-responsive-16by9 -->
                                <!-- <em>Habit Name:</em> {{currenthabitdata.name}}<br/> -->
                                <p style="color:brown;text-align: center;">Purpose: <i>{{currenthabitdata.description}}</i></p>
                                <!-- <em>Check Frequency:</em> {{currenthabitdata.frequency}}</p> -->
                                <div  class="card" v-if="currenthabitdata">
                                    <h5  class="header-box-msg  text-center">Click those you've done: (Remaining: {{ remainingComponents.length }})</h5>
                                    <div v-for="component in currenthabitdata.components" :key="component.id">
                                        <button :id="component.id" class="btn btn-sm btn-primary tracker-btn" style="margin:auto;"
                                        @click="setupDoneComponent(component.id)" ><b>{{component.name}}:</b> ({{component.description}})
                                        </button>
                                        <div hidden :id="'div'+component.id" ><small><span style="color:#55060e;">Recorded: </span><b>{{component.name}}:</b> ({{component.description}}, <em>{{component.weight}} points</em>.)</small></div>
                                    </div>
                                </div>
                                <div>
                                    <button :hidden="savedPerformance" :disabled="remainingComponents.length>0" @click="savePerformance()" class="btn btn-sm btn-warning float-right">Record Your Performance &nbsp;<i class="fas fa-save"></i></button>
                                    <button @click="cancel()" class="btn btn-sm btn-warning float-right">Close &nbsp;<i class="fas fa-times"></i></button>
                                    <!-- <button @click="milestoneAchieved=true" class="btn btn-sm btn-warning float-right">Test Yay Display &nbsp;<i class="fas fa-times"></i></button> -->
                                    <span style="color:#55060e;font-size:x-small;" v-if="message"><br/>{{ message }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios';
import Swal from 'sweetalert2';
var _ = require('lodash');

export default {
    components:{
     },
    name: "ActionHabitsDisplaySelection",
    data() {
        return {
            token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            loading: false,
            errors: {
                header: '',
                hc_add: '',
            },
            userData:'',
            myActionHabitDetails:'',
            selActionHabitID: '',

            selActionHabitData: '',
            elapsedTimeTarget: 90,
            elapsedTime:0,
            startTime:'',
            timerInterval:'',

            currenthabitdata:'',
            remainingComponents: '',
            savedPerformance:false,
            milestoneAchieved:false, //shut down redisplay of yay (if triggered) and if this modal is re-displayed.
            message: '',
            actionhabitcomponents: '',



      }
    },

    props: {

    },
    mounted() {

        this.getMyActionHabitsDetailsData();

    },
    beforeDestroy() {
        this.stopTimer();
    },

    methods: {

            startTimer() {
            this.timerInterval = setInterval(() => {
                const currentTime = new Date();
                this.elapsedTime = Math.floor(
                    (currentTime - this.startTime) / 1000
                );
            }, 1000);
            console.error(this.elapsedTime);
            if(this.elapsedTime >= this.elapsedTimeTarget) {
                console.error('Review  time achieved for ' + this.userinfo.id);
                this.recordKSSReview();
                this.reviewMessage ="Great job!";
                this.stopTimer();
            }
        },
        stopTimer() {
            clearInterval(this.timerInterval);
        },
        // recordKSSReview() {
        //     console.error('Recording review for ' + this.userData.id);
        //      axios.post('/eliminatess/review/save', {
        //         user_id:this.userData.id,
        //         kill_selfsabotage_id:this.selKSSData.id
        //     })
        //     .then(res => {
        //         this.reviewMessage = res.data.message;
        //         this.stopTimer();
        //         console.error(res.data.message);
        //     })
        //     .catch(err => {               ;
        //         console.error(err);
        //     })
        //     .finally(()=> {
        //           this.updateToast(this.reviewMessage, 4000);
        //     });
        // },

       updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },
        displaySelectedActionHabit() {
            this.currenthabitdata = this.getActionHabitData(this.selActionHabitID);
            this.remainingComponents = this.currenthabitdata.components;
            // this.setup2DisplayActionHabit();
            // this.startTimer();

        },
        getMyActionHabitsDetailsData() {
            console.log("getMyActionHabitsDetailsData: " );
            axios.get('/actionhabits/viewinsert')
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message;
                this.userData =JSON.parse(res.data.userdata);
                this.myActionHabitDetails =JSON.parse(res.data.actionhabits);
                // console.error(res.data.message);
            })
            .catch(err => {
                // this.loading = false;
                // this.failure = true;
                console.error(err);
            })
            .finally(()=> {
                this.message = '';
            });
        },

        getActionHabitData(habit_id) {
            console.log("Looking for ActionHabit with id: " + habit_id);
            var retVal = '';
            this.myActionHabitDetails.forEach((aHabit)=>{
                // console.log(aHabit.name + aHabit.id);
                if(aHabit.id == habit_id)  {
                    console.log("Found ActionHabit: " + aHabit.name);
                    retVal =  aHabit;
                }
            });
            return retVal;
        },
        cancel() {
            this.milestoneAchieved = false; //shut down redisplay of yay (if triggered) and if this modal is re-displayed.
            this.message = '';
            this.currenthabitdata = '';
            this.actionhabitcomponents = '';
            this.remainingComponents = '';
            this.savedPerformance= false;
            $('div#display-habit-modal').modal('hide');
        },
         informChart(newdata) {
             this.$root.$emit('updateChart', newdata);
        },
        disableClickedButton(compid) {
            document.getElementById(compid).hidden = true;
            document.getElementById('div'+compid).hidden = false;
        },
        strikeThroughComponent(component_id) {
            const thisEl = document.getElementById(component_id);
            thisEl.style.textDecoration = 'line-through';
            thisEl.disabled = true;
            // console.log('Strikethrough done. pls check');
        },
        trackRemainingComponents(componentid) {
            this.remainingComponents = [...this.remainingComponents].filter(function (component){
                    return component.id != componentid;
                });
        },

        setupDoneComponent(compid) {
            this.strikeThroughComponent(compid);
            this.trackRemainingComponents(compid);
        },

        disableRecordPerfButton(){
            this.savedPerformance = true; //hides the button
        },
        savePerformance() {
            if(this.remainingComponents.length==0) {

            let incomingdata = '';
                console.error("Saving Done on action_habit_id: user_id: " + this.userData.id + ", action_habitID: " + this.currenthabitdata.id);
                axios.post('/actionhabits/tracking/update', {
                    user_id:this.userData.id,
                    action_habit_id: this.currenthabitdata.id,
                })
                .then(res => {
                    this.loading = false;
                    this.success = true;
                    this.message = res.data.message;
                    this.attempt_count = res.data.attempt_count;
                    this.milestoneAchieved = (res.data.attempt_count % 10 === 0);
                    this.attempt_count = res.data.attempt_count;
                    this.failure = false;
                    this.updateToast(this.message, 4000, 'success');
                })
                .catch(err => {
                    this.loading = false;
                    this.failure = true;
                    this.success = false;
                })
                .finally(() => {
                        //  console.error('In delete finally.....');
                        // console.error(incomingdata);
                        this.disableRecordPerfButton();
                        // this.informChart();
                        this.$forceUpdate();
                });
            } else {
                console.error ("Check... this button should not have been clickable")

            }
        },

    },
    watch: {
        elapsedTime(newValue) {
            if (newValue === this.elapsedTimeTarget) {
            this.recordKSSReview();
            }
        }
    },
}
</script>

<style scoped>
.content-box-gray .content {
    overflow: wrap;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
     background:#1a794b;
    font-size:.75em;
    /* font-weight:bold; */
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}


.overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: fadeOut 5s forwards;
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    visibility: hidden;
  }
}

#yayOverlay {
  width: 40vw;
  height: 40vh;
  border: 2px solid #000;
  border-radius: 4px;
  box-shadow: #555 4px 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

}

#yayOverlay.h5 {
  max-width: 100%;
  margin: 0;
  padding: 10px;
  word-wrap: break-word;
}
#yayOverlay.img {
  max-width: 100%;
  max-height: 80%;
  object-fit: contain;
}

@media (max-width: 768px) {
    #yayOverlay.card {
        width: 80vw;
        height: 60vh;
        /* Adjust dimensions and other styles for mobile */
    }
    #yayOverlay.img {
    width: 80%;
    object-fit: contain;
    }
}
.goal-head{
background: #212c3e;
color: #d6a30a;
font-size:small;
text-align:center;
word-wrap: break-word;
  @media (max-width: 768px) {
       font-size:small;
    }
}
.periods-head{
background: #d6a30a;
color: #0f0f0f;
font-size:small;
text-align:center;
word-wrap: break-word;
  @media (max-width: 768px) {
       font-size:small;
    }
}
.component-head{
background: #687b9a;
color: #2003fc;
font-size:small;
text-align:center;
word-wrap: break-word;
  @media (max-width: 768px) {
       font-size:small;
    }
}

ul{
list-style-type: none; /* Remove bullets */
  padding: 0; /* Remove padding */
  margin: 0; /* Remove margins */
    text-align: left;
    font-size: small;
}
.card{
    border:#111 1px solid;
}


</style>
